"use strict";

exports.__esModule = true;
exports.default = void 0;
var _preact = require("preact");
var _classnames = _interopRequireDefault(require("classnames"));
var _remoteFileObjToLocal = _interopRequireDefault(require("@uppy/utils/lib/remoteFileObjToLocal"));
var _hooks = require("preact/hooks");
var _VirtualList = _interopRequireDefault(require("@uppy/utils/lib/VirtualList"));
var _SearchFilterInput = _interopRequireDefault(require("./SearchFilterInput.js"));
var _FooterActions = _interopRequireDefault(require("./FooterActions.js"));
var _index = _interopRequireDefault(require("./Item/index.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /* eslint-disable react/require-default-props */ // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore untyped
var VIRTUAL_SHARED_DIR = 'shared-with-me';
function ListItem(props) {
  var currentSelection = props.currentSelection,
    uppyFiles = props.uppyFiles,
    viewType = props.viewType,
    isChecked = props.isChecked,
    _toggleCheckbox = props.toggleCheckbox,
    recordShiftKeyPress = props.recordShiftKeyPress,
    showTitles = props.showTitles,
    i18n = props.i18n,
    validateRestrictions = props.validateRestrictions,
    getNextFolder = props.getNextFolder,
    f = props.f;
  if (f.isFolder) {
    return (0, _index.default)({
      showTitles: showTitles,
      viewType: viewType,
      i18n: i18n,
      id: f.id,
      title: f.name,
      getItemIcon: function getItemIcon() {
        return f.icon;
      },
      isChecked: isChecked(f),
      toggleCheckbox: function toggleCheckbox(event) {
        return _toggleCheckbox(event, f);
      },
      recordShiftKeyPress: recordShiftKeyPress,
      type: 'folder',
      // TODO: when was this supposed to be true?
      isDisabled: false,
      isCheckboxDisabled: f.id === VIRTUAL_SHARED_DIR,
      // getNextFolder always exists when f.isFolder is true
      handleFolderClick: function handleFolderClick() {
        return getNextFolder(f);
      }
    });
  }
  var restrictionError = validateRestrictions((0, _remoteFileObjToLocal.default)(f), [].concat(_toConsumableArray(uppyFiles), _toConsumableArray(currentSelection)));
  return (0, _index.default)({
    id: f.id,
    title: f.name,
    author: f.author,
    getItemIcon: function getItemIcon() {
      return viewType === 'grid' && f.thumbnail ? f.thumbnail : f.icon;
    },
    isChecked: isChecked(f),
    toggleCheckbox: function toggleCheckbox(event) {
      return _toggleCheckbox(event, f);
    },
    isCheckboxDisabled: false,
    recordShiftKeyPress: recordShiftKeyPress,
    showTitles: showTitles,
    viewType: viewType,
    i18n: i18n,
    type: 'file',
    isDisabled: Boolean(restrictionError) && !isChecked(f),
    restrictionError: restrictionError
  });
}
function Browser(props) {
  var currentSelection = props.currentSelection,
    folders = props.folders,
    files = props.files,
    uppyFiles = props.uppyFiles,
    viewType = props.viewType,
    headerComponent = props.headerComponent,
    showBreadcrumbs = props.showBreadcrumbs,
    isChecked = props.isChecked,
    toggleCheckbox = props.toggleCheckbox,
    recordShiftKeyPress = props.recordShiftKeyPress,
    handleScroll = props.handleScroll,
    showTitles = props.showTitles,
    i18n = props.i18n,
    validateRestrictions = props.validateRestrictions,
    isLoading = props.isLoading,
    showSearchFilter = props.showSearchFilter,
    search = props.search,
    searchTerm = props.searchTerm,
    clearSearch = props.clearSearch,
    searchOnInput = props.searchOnInput,
    searchInputLabel = props.searchInputLabel,
    clearSearchLabel = props.clearSearchLabel,
    getNextFolder = props.getNextFolder,
    cancel = props.cancel,
    done = props.done,
    noResultsLabel = props.noResultsLabel,
    virtualList = props.virtualList;
  var selected = currentSelection.length;
  var rows = (0, _hooks.useMemo)(function () {
    return [].concat(_toConsumableArray(folders), _toConsumableArray(files));
  }, [folders, files]);
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('uppy-ProviderBrowser', "uppy-ProviderBrowser-viewType--".concat(viewType))
  }, headerComponent && (0, _preact.h)("div", {
    className: "uppy-ProviderBrowser-header"
  }, (0, _preact.h)("div", {
    className: (0, _classnames.default)('uppy-ProviderBrowser-headerBar', !showBreadcrumbs && 'uppy-ProviderBrowser-headerBar--simple')
  }, headerComponent)), showSearchFilter && (0, _preact.h)("div", {
    class: "uppy-ProviderBrowser-searchFilter"
  }, (0, _preact.h)(_SearchFilterInput.default, {
    search: search,
    searchTerm: searchTerm,
    clearSearch: clearSearch,
    inputLabel: searchInputLabel,
    clearSearchLabel: clearSearchLabel,
    inputClassName: "uppy-ProviderBrowser-searchFilterInput",
    searchOnInput: searchOnInput
  })), function () {
    if (isLoading) {
      return (0, _preact.h)("div", {
        className: "uppy-Provider-loading"
      }, (0, _preact.h)("span", null, typeof isLoading === 'string' ? isLoading : i18n('loading')));
    }
    if (!folders.length && !files.length) {
      return (0, _preact.h)("div", {
        className: "uppy-Provider-empty"
      }, noResultsLabel);
    }
    if (virtualList) {
      return (0, _preact.h)("div", {
        className: "uppy-ProviderBrowser-body"
      }, (0, _preact.h)("ul", {
        className: "uppy-ProviderBrowser-list"
      }, (0, _preact.h)(_VirtualList.default, {
        data: rows,
        renderRow: function renderRow(f) {
          return (0, _preact.h)(ListItem, {
            currentSelection: currentSelection,
            uppyFiles: uppyFiles,
            viewType: viewType,
            isChecked: isChecked,
            toggleCheckbox: toggleCheckbox,
            recordShiftKeyPress: recordShiftKeyPress,
            showTitles: showTitles,
            i18n: i18n,
            validateRestrictions: validateRestrictions,
            getNextFolder: getNextFolder,
            f: f
          });
        },
        rowHeight: 31
      })));
    }
    return (0, _preact.h)("div", {
      className: "uppy-ProviderBrowser-body"
    }, (0, _preact.h)("ul", {
      className: "uppy-ProviderBrowser-list",
      onScroll: handleScroll,
      role: "listbox"
      // making <ul> not focusable for firefox
      ,

      tabIndex: -1
    }, rows.map(function (f) {
      return (0, _preact.h)(ListItem, {
        currentSelection: currentSelection,
        uppyFiles: uppyFiles,
        viewType: viewType,
        isChecked: isChecked,
        toggleCheckbox: toggleCheckbox,
        recordShiftKeyPress: recordShiftKeyPress,
        showTitles: showTitles,
        i18n: i18n,
        validateRestrictions: validateRestrictions,
        getNextFolder: getNextFolder,
        f: f
      });
    })));
  }(), selected > 0 && (0, _preact.h)(_FooterActions.default, {
    selected: selected,
    done: done,
    cancel: cancel,
    i18n: i18n
  }));
}
var _default = exports.default = Browser;